export default "__VITE_ASSET__DDh$$uYn__"